import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { forEach } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';
import { List } from '../../../../core/models/list.model';
import { CommonUtilService } from '../../../../shared/services/CommonUtil.service';
import { Lists } from '../../../../shared/services/lists.service';
import { ContactsService } from '../../../contacts/services/contacts.service';
import { ListApiService, TagsApiService } from '../../../../shared/services/api';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ListItemDto, SaveTagDto, TagsDto } from '../../../../shared/dto';
import {  MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CREATE_TAG_LOADING_TAG, GET_TAG_LOADING_TAG } from 'src/app/shared/constants';
import { LoadingService, TagService } from 'src/app/shared/services';

@UntilDestroy()
@Component({
    selector: 'app-create-contact-list',
    templateUrl: './create-contact-list.component.html',
    styleUrls: ['./create-contact-list.component.scss'],
    standalone: false
})
export class CreateContactListComponent implements OnInit, OnDestroy {
    @ViewChild('listFile') listFile: ElementRef;

    readonly isCreateTagLoading$: Observable<boolean> = this.loadingService.getIsLoading(CREATE_TAG_LOADING_TAG);
    readonly isGetTagLoading$: Observable<boolean> = this.loadingService.getIsLoading(GET_TAG_LOADING_TAG);


    public pages = {
        uploadListPage: 0,
        columnMappingPage: 1,
        resultPage: 2
    };

    headers = [{
        Title: 'Contacts',
        Description: 'Upload your contacts',
        IsDone: false,
        IsActive: true
    }, {
        Title: 'Map Fields',
        Description: 'Assign csv columns to contact fields',
        IsDone: false,
        IsActive: false
    }, {
        Title: 'Results',
        Description: 'View match rate and download results',
        IsDone: false,
        IsActive: false
    }];

    currentPage = 0;
    isListProcessing = false;
    existingLists: ListItemDto[] = [];
    isError;
    list: List = new List();
    fileHeaders = undefined;
    selectedColumnValues = {
        firstName: '0',
        lastName: '0',
        company: '0',
        companyDomain: '0',
        email: '0',
        matchId: '0',
        workPhone: '0',
        mobilePhone: '0',
        title: '0',
        hqPhone: '0',
        linkedinUrl: '0'
    };

    columnStepDetails = [
        { displayName: 'First Name', propertyName: 'firstName', isError: false },
        { displayName: 'Last Name', propertyName: 'lastName', isError: false },
        { displayName: 'Company', propertyName: 'company', isError: false },
        { displayName: 'Company Domain', propertyName: 'companyDomain', isError: false },
        { displayName: 'Email', propertyName: 'email', isError: false },
        { displayName: 'Contact Identifier', propertyName: 'matchId', isError: false },
        { displayName: 'Work Phone', propertyName: 'workPhone', isError: false },
        { displayName: 'Mobile Phone', propertyName: 'mobilePhone', isError: false },
        { displayName: 'Job Title', propertyName: 'title', isError: false },
        { displayName: 'HQ Phone', propertyName: 'hqPhone', isError: false },
        { displayName: 'LinkedIn Url', propertyName: 'linkedinUrl', isError: false }
    ];

    nextButtonCaption = 'Next';
    totalAccounts = 0;
    totalVerifiedAppendCompanyCount = 0;
    totalVerifiedAppendTitleCount = 0;
    totalVerifiedAppendEmailCount = 0;
    totalVerifiedAppendDirectDialCount = 0;
    totalVerifiedAppendMobilePhoneCount = 0;
    totalVerifiedAppendWorkPhoneCount = 0;
    totalVerifiedAppendHQPhoneCount = 0;
    totalPendingVerificationAppendCompanyCount = 0;
    totalPendingVerificationAppendTitleCount = 0;
    totalPendingVerificationAppendEmailCount = 0;
    totalPendingVerificationAppendDirectDialCount = 0;
    totalPendingVerificationAppendMobilePhoneCount = 0;
    totalPendingVerificationAppendWorkPhoneCount = 0;
    totalPendingVerificationAppendHQPhoneCount = 0;
    verifiedAppendMatchIds = [];
    pendingVerificationAppendMatchIds = [];
    verifiedMatchIds = [];
    pendingVerificationMatchIds = [];
    totalContacts = 0;
    totalValidContacts = 0;
    totalVerifiedContacts = 0;
    totalPendingVerificationContacts = 0;
    loggedInUserData;
    subscriber: any;
    listname;
    selectedView = 0;
    contactDetail: any;

    tagList$: Observable<TagsDto[]>;

    constructor(
        private listsService: Lists,
        private toastr: ToastrService,
        public contactsService: ContactsService,
        public commonUtilService: CommonUtilService,
        private readonly listApiService: ListApiService,
        private readonly matDialogRef: MatDialogRef<CreateContactListComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: any,
        private readonly tagsApiService: TagsApiService,
        private readonly loadingService: LoadingService,
        private readonly tagService: TagService
    ) {
        this.list.type = 'Contacts';
        if (this.data) {
            if (this.data['id']) {
                this.list.id = this.data['id'];
                this.list.matchOnJobHistory = this.data['matchOnJobHistory'];
                this.list.name = this.list.name ? this.list.name : this.data['name'];
                this.currentPage = 2;
                this.contactsService.createContactLoadedFlag.next(true);
                this.getListDetails();
                this.setNextButtonCaption();
                this.headers = [{
                    Title: this.list.name,
                    Description: '',
                    IsDone: false,
                    IsActive: true
                }];
            } else {
                this.list.matchOnJobHistory = true;
            }
            if (this.data['files']) {
                this.list.file = this.data['files'];
                this.list.fileName = this.list.file['name'];
            }
        }
    }

    ngOnInit() {
        this.listsService.listData$.pipe(untilDestroyed(this)).subscribe((response: ListItemDto[]) => {
            this.existingLists = response;
        });
        this.setTagsList();
    }

    createTag(tagName: string): void {
        const createObj: SaveTagDto = {
            name: tagName
        }
        this.loadingService.loadingWrapper(this.tagsApiService.createTag(createObj), CREATE_TAG_LOADING_TAG).pipe(untilDestroyed(this)).subscribe((newTag: TagsDto) => {
            this.list = {...this.list, tags: [...this.list.tags, newTag.id]};
            this.tagService.refreshList();
            this.toastr.success("Tag created successfully");
        })
    }

    ngOnDestroy() {
        if (this.subscriber) {
            this.subscriber.unsubscribe();
        }
    }
    close(): void {
        this.matDialogRef.close();
    }

    onNext(): void {
        switch (this.currentPage) {
            case this.pages.uploadListPage:
                this.createPreviewList();
                break;
            case this.pages.columnMappingPage:
                this.isListProcessing = true;
                this.contactsService.createContactLoadedFlag.next(true);
                this.createList();
                break;
            default:
                this.close();
                break;
        }
    }

    onPrevious(): void {
        this.headers[this.currentPage].IsDone = false;
        this.headers[this.currentPage].IsActive = false;
        this.currentPage--;
        this.headers[this.currentPage].IsActive = true;
        this.headers[this.currentPage].IsDone = false;
        this.setNextButtonCaption();
    }

    onFileSelected(event) {
        if (event.target.files.length > 0) {
            this.list.file = event.target.files[0];
            this.list.fileName = event.target.files[0].name;
        }
    }

    private setTagsList(): void {
        this.tagList$ = this.tagService.getTagsList();
    }

    private createPreviewList() {
        const listName = this.list.name === undefined ? '' : this.list.name.trim();
        const nameExist = this.existingLists.filter((item) => item.name.toLowerCase() === listName.toLowerCase()).length > 0;
        const filename = this.list.fileName;
        const fileParts = filename.split('.');
        const extension = fileParts[fileParts.length - 1];
        if (listName === '') {
            this.commonUtilService.showToastWithError('List Name is required');
            return;
        }
        if (filename === '') {
            this.commonUtilService.showToastWithError('CSV File is required');
            return;
        }
        if (nameExist) {
            this.commonUtilService.showToastWithError('You already have a list with this name. Please choose a different name.');
            return;
        }
        if (extension !== 'csv' && extension !== 'txt') {
            this.commonUtilService.showToastWithError('Only .txt or .csv files are supported. Please choose a file with one of those two extensions.');
            return;
        }

        this.isListProcessing = true;
        this.contactsService.createContactLoadedFlag.next(true);
        this.listsService.createPreviewList(this.list, this.list.matchOnJobHistory).subscribe((response) => {
            this.isListProcessing = false;
            this.contactsService.createContactLoadedFlag.next(false);
            this.fileHeaders = response.columns[0].split(',');
            forEach(this.fileHeaders, (value, index) => {
                const lowerCaseValue = (value.toLowerCase()).trim();
                // firstName
                if (lowerCaseValue === 'firstname' || lowerCaseValue === 'first name' || lowerCaseValue === 'first_name'
                    || lowerCaseValue === 'first') {
                    this.selectedColumnValues.firstName = index + 1;
                }

                // lastName
                if (lowerCaseValue === 'lastname' || lowerCaseValue === 'last name' || lowerCaseValue === 'last_name'
                    || lowerCaseValue === 'last') {
                    this.selectedColumnValues.lastName = index + 1;
                }

                // company
                if (lowerCaseValue === 'company' || lowerCaseValue === 'organization' || lowerCaseValue === 'organisation'
                    || lowerCaseValue === 'org' || lowerCaseValue === 'company name' || lowerCaseValue === 'companyname' || lowerCaseValue === 'corporation'
                    || lowerCaseValue === 'enterprise' || lowerCaseValue === 'firm' || lowerCaseValue === 'name') {
                    this.selectedColumnValues.company = index + 1;
                }

                // companyDomain
                if (lowerCaseValue === 'website' || lowerCaseValue === 'site' || lowerCaseValue === 'link' || lowerCaseValue === 'webpage' || lowerCaseValue === 'web page'
                    || lowerCaseValue === 'homepage' || lowerCaseValue === 'home page' || lowerCaseValue === 'domain' || lowerCaseValue === 'url') {
                    this.selectedColumnValues.companyDomain = index + 1;
                }

                // email
                if (lowerCaseValue === 'email' || lowerCaseValue === 'emailaddress' || lowerCaseValue === 'emailaddr' || lowerCaseValue === 'email address') {
                    this.selectedColumnValues.email = index + 1;
                }

                // contactIdentifier
                if (lowerCaseValue === 'id' || lowerCaseValue === 'contactid' || lowerCaseValue === 'contact_id'
                    || lowerCaseValue === 'match_id' || lowerCaseValue === 'matchid') {
                    this.selectedColumnValues.matchId = index + 1;
                }

                // workPhone
                if (lowerCaseValue === 'work_phone' || lowerCaseValue === 'workphone' || lowerCaseValue === 'work phone') {
                    this.selectedColumnValues.workPhone = index + 1;
                }

                // mobilePhone
                if (lowerCaseValue === 'work_mobile' || lowerCaseValue === 'workmobile' || lowerCaseValue === 'work mobile'
                    || lowerCaseValue === 'mobile' || lowerCaseValue === 'mobilephone' || lowerCaseValue === 'mobile_phone'
                    || lowerCaseValue === 'mobile phone') {
                    this.selectedColumnValues.mobilePhone = index + 1;
                }

                // title: '0',
                if (lowerCaseValue === 'job title' || lowerCaseValue === 'job' || lowerCaseValue === 'jobtitle'
                    || lowerCaseValue === 'job_title' || lowerCaseValue === 'title' || lowerCaseValue === 'designation' || lowerCaseValue === 'role') {
                    this.selectedColumnValues.title = index + 1;
                }

                // hqPhone: '0',
                if (lowerCaseValue === 'company phone' || lowerCaseValue === 'main phone' || lowerCaseValue === 'hq phone'
                    || lowerCaseValue === 'hqphone' || lowerCaseValue === 'hq_phone') {
                    this.selectedColumnValues.hqPhone = index + 1;
                }

                // linkedinUrl: '0'
                if (lowerCaseValue === 'linkedin' || lowerCaseValue === 'linkedinurl' || lowerCaseValue === 'linkedin_url'
                    || lowerCaseValue === 'linkedin url' || lowerCaseValue === 'liurl' || lowerCaseValue === 'li_url'
                    || lowerCaseValue === 'li') {
                    this.selectedColumnValues.linkedinUrl = index + 1;
                }
            });
            this.proceedToNextStep();
            this.setNextButtonCaption();
        }, () => {
            this.isListProcessing = false;
            this.contactsService.createContactLoadedFlag.next(false);
        });
    }
    private createList() {
        if ((this.selectedColumnValues.firstName === '0' || this.selectedColumnValues.lastName === '0' || this.selectedColumnValues.companyDomain === '0')
            && (this.selectedColumnValues.firstName === '0' || this.selectedColumnValues.lastName === '0' || this.selectedColumnValues.company === '0')
            && (this.selectedColumnValues.firstName === '0' || this.selectedColumnValues.lastName === '0' || this.selectedColumnValues.mobilePhone === '0')
            && (this.selectedColumnValues.firstName === '0' || this.selectedColumnValues.lastName === '0' || this.selectedColumnValues.workPhone === '0')
            && (this.selectedColumnValues.email === '0') && (this.selectedColumnValues.matchId === '0') && (this.selectedColumnValues.linkedinUrl === '0')) {
            this.contactsService.createContactLoadedFlag.next(false);
            this.isError = 'Your file must contain either email address OR LinkedIn url OR first name, last name and company domain OR first name, last name and company OR first name, last name and phone.';
            this.isListProcessing = false;
            return;
        }
        const isDuplicate = this.commonUtilService.checkDupicateMappings(this.selectedColumnValues, this.columnStepDetails);
        if (isDuplicate === false) {
            this.list.columnMapping = this.selectedColumnValues;
            this.list.name = this.list.name === undefined ? '' : this.list.name.trim();
            this.listsService.createList(this.list, this.list.matchOnJobHistory).subscribe((response) => {
                this.listsService.refreshLists();
                this.list.id = response.id;
                this.listname = response.name;
                this.getListDetails();
                this.proceedToNextStep();
                this.setNextButtonCaption();
                this.isListProcessing = false;
            }, () => {
                this.isListProcessing = false;
                this.contactsService.createContactLoadedFlag.next(false);
            });
        } else {
            this.contactsService.createContactLoadedFlag.next(false);
            this.isListProcessing = false;
        }
    }

    private getListDetails() {
        this.subscriber = this.listApiService.getListDetails(this.list.id, this.list.matchOnJobHistory).pipe(untilDestroyed(this)).subscribe((response) => {
            this.totalAccounts = response.length;

            this.subscriber = this.listApiService.analyzeContactList(this.list.id, this.list.matchOnJobHistory).pipe(untilDestroyed(this)).subscribe((responseData) => {
                this.contactDetail = responseData;
                this.totalVerifiedAppendCompanyCount = responseData.append_company_count_verified;
                this.totalVerifiedAppendTitleCount = responseData.append_title_count_verified;
                this.totalVerifiedAppendEmailCount = responseData.append_email_count_verified;
                this.totalVerifiedAppendDirectDialCount = responseData.append_directdial_count_verified;
                this.totalVerifiedAppendMobilePhoneCount = responseData.append_mobilephone_count_verified;
                this.totalVerifiedAppendWorkPhoneCount = responseData.append_workphone_count_verified;
                this.totalVerifiedAppendHQPhoneCount = responseData.append_hqphone_count_verified;

                this.totalPendingVerificationAppendCompanyCount = responseData.append_company_count_pending_verification;
                this.totalPendingVerificationAppendTitleCount = responseData.append_title_count_pending_verification;
                this.totalPendingVerificationAppendEmailCount = responseData.append_email_count_pending_verification;
                this.totalPendingVerificationAppendDirectDialCount = responseData.append_directdial_count_pending_verification;
                this.totalPendingVerificationAppendMobilePhoneCount = responseData.append_mobilephone_count_pending_verification;
                this.totalPendingVerificationAppendWorkPhoneCount = responseData.append_workphone_count_pending_verification;
                this.totalPendingVerificationAppendHQPhoneCount = responseData.append_hqphone_count_pending_verification;

                this.totalContacts = responseData.total_contacts;
                this.totalValidContacts = responseData.total_valid_contacts;
                this.totalVerifiedContacts = responseData.verified_count;
                this.totalPendingVerificationContacts = responseData.pending_verification_count;

                this.verifiedMatchIds = responseData.verified_match_ids;
                this.pendingVerificationMatchIds = responseData.pending_verification_match_ids;
                this.verifiedAppendMatchIds = responseData.append_match_ids_verified;
                this.pendingVerificationAppendMatchIds = responseData.append_match_ids_pending_verification;
                this.contactsService.createContactLoadedFlag.next(false);
            }, (error) => {
                this.contactsService.createContactLoadedFlag.next(false);
                this.commonUtilService.showToastWithError(error?.message);
            });

        }, (error) => {
            this.contactsService.createContactLoadedFlag.next(false);
            this.commonUtilService.showToastWithError(error?.message);
        });
    }

    private proceedToNextStep() {
        this.headers[this.currentPage].IsDone = true;
        this.headers[this.currentPage].IsActive = false;
        this.currentPage++;
        this.headers[this.currentPage].IsActive = true;
    }

    private setNextButtonCaption() {
        switch (this.currentPage) {
            case 1:
                this.nextButtonCaption = 'Save List';
                break;
            case 2:
                this.nextButtonCaption = 'Close';
                break;
            default:
                this.nextButtonCaption = 'Next';
                break;
        }
    }

    isNextButtonDisabled() {
        if (this.currentPage === 0) {
            return this.list.fileName === undefined || this.list.fileName === '' || this.list.name === undefined || this.list.name === '';
        }

        return false;
    }

    resetFile() {
        this.fileHeaders = undefined;
        this.list.file = undefined;
        this.list.fileName = undefined;
        this.listFile.nativeElement.value = '';
        this.selectedColumnValues.company = '0';
        this.selectedColumnValues.companyDomain = '0';
        this.selectedColumnValues.email = '0';
        this.selectedColumnValues.firstName = '0';
        this.selectedColumnValues.hqPhone = '0';
        this.selectedColumnValues.lastName = '0';
        this.selectedColumnValues.linkedinUrl = '0';
        this.selectedColumnValues.matchId = '0';
        this.selectedColumnValues.mobilePhone = '0';
        this.selectedColumnValues.title = '0';
        this.selectedColumnValues.workPhone = '0';
    }

    onChangeType(view: string) {
        if (view === 'contactView') {
            this.selectedView = 0;
        } else {
            this.selectedView = 1;
        }
    }

}
